import React from 'react'

class NachweisFileIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22" viewBox="0 0 17 22">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#72C1FF"
            fillRule="nonzero"
            d="M.661 0H12.01l4.804 4.889v16.45a.661.661 0 0 1-.66.661H.66A.661.661 0 0 1 0 21.34V.66A.661.661 0 0 1 .661 0z"
            opacity=".4"
          />
          <path fill="#6696C7" d="M12.01 0l4.803 4.889h-4.142a.661.661 0 0 1-.662-.661V0z" opacity=".5" />
        </g>
      </svg>
    )
  }
}

export default NachweisFileIcon
